import { useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const PhotoPicker = ({ value, onChange, onBusy }) => {
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const setB = (b) => { setBusy(b); onBusy?.(b); };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    const fd = new FormData();
    fd.append("file", file);
    setB(true);
    try {
      const { data } = await api.post("/public/upload", fd);
      onChange(data.url);
    } catch (err) {
      setPreview("");
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setB(false); }
  };

  return (
    <label data-testid="checkout-photo-drop" className="relative flex aspect-[16/9] cursor-pointer flex-col items-center justify-center gap-2 overflow-hidden rounded-[4px] border border-dashed border-[#b08a3e]/50 bg-white/60 text-sm text-[#4a4440] hover:bg-white">
      {preview ? (
        <>
          <img src={preview} alt="Sua foto" className="absolute inset-0 h-full w-full object-cover" />
          {busy && <span className="absolute inset-0 grid place-items-center bg-white/60"><Loader2 className="h-6 w-6 animate-spin text-[#8a6a2c]" /></span>}
          {!busy && value && <button type="button" data-testid="checkout-photo-remove" onClick={(e) => { e.preventDefault(); onChange(""); setPreview(""); }} className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-full bg-[#1d1a17] text-white"><X className="h-4 w-4" /></button>}
        </>
      ) : (
        <><ImagePlus className="h-6 w-6 text-[#8a6a2c]" strokeWidth={1.4} /><span className="font-jost text-xs tracking-[0.15em]">ENVIAR A FOTO DA CANECA (OPCIONAL)</span></>
      )}
      <input data-testid="checkout-photo-input" type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} />
    </label>
  );
};
